export const indWVsIreWMyContestList = [
  {
    _id: '63f1c14948811c001df8915e',
    createdOn: '2022-05-20T08:49:36.498Z',
    deletedOn: null,
    contestTypeId: '62822a22766a0e627fd8be77',
    contestCategoryId: '6182d541b276f100214b1859',
    tenant: 'gamio',
    title: 'CAT NO ZC CFM 9',
    description: 'CFM',
    minimumPlayers: 4,
    maximumPlayers: 4,
    maxTeamPerUser: 1,
    winningsAmount: 2800,
    entryFee: 900,
    winningsPerPosition: {
      '2800': 1
    },
    selfReplicating: true,
    bonusPercentage: 5,
    isConfirmed: false,
    isDynamicWinnings: false,
    adminFees: 800,
    requiredBucketNumber: 0,
    bucketSize: 0,
    minimumBasePayToEachWinner: 0,
    firstPositionPercentage: 15,
    percentageWinningsFromTotal: 50,
    matchDelayed: false,
    adminContest: false,
    matchId: '63f0d1accd82c2527e625fe8',
    isCanceled: false,
    status: 1,
    statusText: 'Scheduled',
    gameState: 0,
    gameStateText: 'Default',
    calculatedPrizeMoney: 0,
    winningsLocked: false,
    adminVerified: false,
    states: {
      '1': true
    },
    verified: false,
    filledTeamSlots: 2,
    contestTeams: [
      {
        _id: '63f327d948811c001df891f6',
        contestId: '63f1c14948811c001df8915e',
        tenant: 'gamio',
        matchScoreId: '63f3278248811c001df891f5',
        userId: '5fd32b93eaf661ea51eae8af',
        winning: 0,
        rank: 1,
        createdOn: '2023-02-20T07:57:13.460Z',
        deletedOn: null
      }
    ]
  }
];
export const kolVsLsgMyContestList = [
  {
    _id: '6284c74ff19d86001d6c04b7',
    createdOn: '2022-05-16T10:56:56.018Z',
    deletedOn: null,
    contestTypeId: '62822a22766a0e627fd8be77',
    contestCategoryId: '6182d541b276f100214b1859',
    tenant: 'gamio',
    title: 'CAT CFM YN 37',
    description: 'YN',
    minimumPlayers: 3,
    maximumPlayers: 3,
    maxTeamPerUser: 1,
    winningsAmount: 11100,
    entryFee: 3700,
    winningsPerPosition: {
      '11100': 1
    },
    selfReplicating: true,
    bonusPercentage: 0,
    isConfirmed: false,
    isDynamicWinnings: false,
    adminFees: 0,
    requiredBucketNumber: 0,
    bucketSize: 0,
    minimumBasePayToEachWinner: 0,
    firstPositionPercentage: 15,
    percentageWinningsFromTotal: 50,
    matchDelayed: false,
    adminContest: false,
    matchId: '628240bd6d0713b9cf82d75c',
    isCanceled: false,
    status: 2,
    statusText: 'Completed',
    gameState: 0,
    gameStateText: 'Default',
    calculatedPrizeMoney: 0,
    winningsLocked: false,
    filledTeamSlots: 3,
    adminVerified: true,
    modifiedOn: '2022-05-18T17:58:00.023Z',
    states: {
      '2': true,
      '3': true
    },
    verified: true,
    winningStatus: 'COMPLETED',
    contestTeams: [
      {
        _id: '6284d55784ba3b001dc014ba',
        contestId: '6284c74ff19d86001d6c04b7',
        tenant: 'gamio',
        matchScoreId: '6284d55184ba3b001dc014b9',
        userId: '5fd32b93eaf661ea51eae8af',
        winning: 0,
        rank: 3,
        createdOn: '2022-05-18T11:15:35.578Z',
        deletedOn: null
      }
    ]
  }
];
export const punVsDcMyCOntestList = [
  {
    _id: '6282428fb7c1c9001ff32edb',
    createdOn: '2022-05-16T11:04:01.516Z',
    deletedOn: null,
    contestTypeId: '62822a22766a0e627fd8be75',
    contestCategoryId: '6182d430b276f100214b1851',
    tenant: 'gamio',
    title: 'CAT H2H YN 54',
    description: 'h2h',
    minimumPlayers: 2,
    maximumPlayers: 2,
    maxTeamPerUser: 1,
    winningsAmount: 10800,
    entryFee: 5400,
    winningsPerPosition: {
      '10800': 1
    },
    selfReplicating: true,
    bonusPercentage: 0,
    isConfirmed: false,
    isDynamicWinnings: false,
    adminFees: 0,
    requiredBucketNumber: 0,
    bucketSize: 0,
    minimumBasePayToEachWinner: 0,
    firstPositionPercentage: 15,
    percentageWinningsFromTotal: 50,
    matchDelayed: false,
    adminContest: false,
    matchId: '627fbf7d6d0713b9cf388229',
    isCanceled: false,
    status: 2,
    statusText: 'Completed',
    gameState: 0,
    gameStateText: 'Default',
    calculatedPrizeMoney: 0,
    winningsLocked: false,
    adminVerified: true,
    modifiedOn: '2022-05-16T18:00:00.054Z',
    states: {
      '1': true,
      '2': true,
      '3': true
    },
    verified: true,
    filledTeamSlots: 2,
    winningStatus: 'COMPLETED',
    contestTeams: [
      {
        _id: '62824f5f84ba3b001dbfed18',
        contestId: '6282428fb7c1c9001ff32edb',
        tenant: 'gamio',
        matchScoreId: '628242eb92265b002053978b',
        userId: '5fd32b93eaf661ea51eae8af',
        winning: 0,
        rank: 2,
        createdOn: '2022-05-16T13:19:27.768Z',
        deletedOn: null
      }
    ]
  }
];
